(function($){

    /**
     * initializeBlock
     *
     * Adds custom JavaScript to the block HTML.
     *
     * @date    15/4/19
     * @since   1.0.0
     *
     * @param   object $block The block jQuery element.
     * @param   object attributes The block attributes (only available when editing).
     * @return  void
     */

    let initializeBlock = function( $block ) {

        let slider   = $block.find('.slider-activity');
        let slide    = $block.find('.slide-activity');
        let controls = $block.find('.slider-controls');

        let sliderSettings = {
            slide         : '.slide-activity',
            rows          : 0,                            // fix bug to make slide param works (https://stackoverflow.com/questions/30036742/jquery-slick-carousel-slide-setting)
            arrows        : true,
            appendArrows  : $(controls),
            prevArrow     : $block.find('.slick-prev'),
            nextArrow     : $block.find('.slick-next'),
            speed         : 500,
            cssEase       : 'ease-in-out',
            infinite      : false,
            slidesToShow  : 6,
            slidesToScroll: 6,

            responsive: [
                {
                    breakpoint: 1441,
                    settings  : {
                        slidesToShow  : 5,
                        slidesToScroll: 5,
                    }
                },
                {
                    breakpoint: 1151,
                    settings  : {
                        slidesToShow  : 4,
                        slidesToScroll: 4,
                    }
                },
                {
                    breakpoint: 851,
                    settings  : {
                        slidesToShow  : 3,
                        slidesToScroll: 3,
                    }
                },
                {
                    breakpoint: 641,
                    settings  : {
                        speed         : 250,
                        cssEase       : 'ease-out',
                        touchThreshold: 12,
                        slidesToShow  : 2,
                        slidesToScroll: 2,
                    }
                },
                {
                    breakpoint: 451,
                    settings  : {
                        speed         : 250,
                        cssEase       : 'ease-out',
                        touchThreshold: 12,
                        slidesToShow  : 1,
                        slidesToScroll: 1,
                        centerMode    : true,
                        centerPadding : '50px',
                    }
                },
            ],
        };

        if ($(slide).length  > 1) {
            $(slider).slick(sliderSettings);
        }

    }



    //        Init blocks in front and admin editor
    // ==============================================

    // Initialize each block on page load (front end).
    $(document).ready(function(){
        $('.block-activity').each(function(){
            initializeBlock( $(this) );
        });
    });

    // Initialize dynamic block preview (editor).
    if( window.acf ) {
        window.acf.addAction( 'render_block_preview/type=activity', initializeBlock );
    }

})(jQuery);